import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useBooking } from "./BookingContext";

const Packages = forwardRef((props, ref) => {
  const { bookingData, updateBookingData } = useBooking();
  const [isDedicatedModalOpen, setIsDedicatedModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    // openDedicatedModal removed
  }));

  // Dedicated contact state and handlers removed

  const handlePackageChange = (value) => {
    const packageValue = value;
    console.log("Package changing to:", packageValue);

    updateBookingData("package", packageValue);
    // Also save to localStorage for jQuery access
    localStorage.setItem("selectedPackage", packageValue);
  };



  return (
    <div className="step-content-field">
      <div className="plan-area cards">
        <div
          className={`plan-icon-text text-center pkg h-card ${bookingData.package === "basic" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handlePackageChange("basic");
          }}
        >
          <div className="plan-icon icon-color">
            <i className="fas fa-cubes icon-color"></i>
          </div>
          <div className="plan-text">
            <h3>
              Basic Package <span id="basic" style={{ fontSize: 19 }}></span>
            </h3>
            <ul style={{ fontSize: 15 }}>
              <li>
                {" "}
                <i className="fas fa-check text-success mr-1"></i>Workspace
              </li>
              <li>
                <i className="fas fa-check text-success mr-1"></i>Power Supply
              </li>
              <li>
                <i className="fas fa-check text-success mr-1"></i>Internet
              </li>
            </ul>
            <input
              type="radio"
              name="package"
              value="basic"
              checked={bookingData.package === "basic"}
              readOnly
            />
          </div>
        </div>

        <div
          className={`plan-icon-text text-center pkg h-card ${bookingData.package === "private" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handlePackageChange("private");
          }}
        >
          <div className="plan-icon icon-color">
            <i className="fas fa-chess-queen icon-color"></i>
          </div>
          <div className="plan-text">
            <h3>
              Private Office <br />{" "}
              <span id="private" style={{ fontSize: 19 }}></span>
            </h3>
            <ul style={{ fontSize: 15 }}>
              <li>
                <i className="fas fa-check text-success mr-1"></i>Private Office
              </li>
              <li>
                <i className="fas fa-check text-success mr-1"></i>Power Supply
              </li>
              <li>
                <i className="fas fa-check text-success mr-1"></i>Internet
              </li>
            </ul>
            <input
              type="radio"
              name="package"
              value="private"
              checked={bookingData.package === "private"}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
});

export default Packages;
